import EditorialPageHeader from "./EditorialPageHeader";
import { FeatureGateProvider } from "../contexts/FeatureGateContext";
import { useAuth } from "../App";
export default function EmbeddedAdminLayout({ children, title, subtitle, actions, headerEyebrow }) {
  const { user } = useAuth();
  return <FeatureGateProvider orgId={user?.org_id}>{title && <EditorialPageHeader eyebrow={headerEyebrow || "Organization operations"} title={title} description={subtitle} aside={actions} headingId="admin-page-title" className="mb-6" />}{children}</FeatureGateProvider>;
}
